import { asc, count } from "drizzle-orm";
import { organization, type PowerSyncDrizzleDB } from "@custodia/powersync";

/**
 * Shared Drizzle query builder for fetching organization counts.
 */
export function getOrganizationCountQuery(db: PowerSyncDrizzleDB) {
  return db
    .select({
      count: count(organization.id).mapWith(Number),
    })
    .from(organization);
}

/**
 * Locally synchronized organizations (user's organizations: the `organizations`
 * stream only downloads those where the user is a member), sorted by name.
 */
export function getLocalOrganizationsQuery(db: PowerSyncDrizzleDB) {
  return db.select().from(organization).orderBy(asc(organization.name));
}
